export default __webpack_public_path__ + "static/media/partly-cloudy-day.7a57570c.svg";